import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/**
 * @author PKr
 */


import { action, observable, runInAction } from 'mobx';
import { StoreName } from '../StoreName';
import { BaseStore } from '../BaseStore';
import { SupplierAgreementLayer } from '../../transportLayers/supply/SupplierAgreementLayer';
/**
 * This store obtaining data of price zones.
 */

export var SupplierAgreementStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(SupplierAgreementStore, _BaseStore);

  function SupplierAgreementStore() {
    var _this;

    _classCallCheck(this, SupplierAgreementStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SupplierAgreementStore).apply(this, arguments));
    _this.name = StoreName.SupplierAgreement;
    _this.supplierAgreementLayer = new SupplierAgreementLayer();
    _this.list = new Map();
    return _this;
  }

  _createClass(SupplierAgreementStore, [{
    key: "getAll",
    value: function getAll() {
      var _this2 = this;

      return this.supplierAgreementLayer.findAll().then(function (agreements) {
        agreements.forEach(function (agreement) {
          runInAction(function () {
            _this2.list.set(agreement.id, agreement);
          });
        });
        return _this2.list;
      }).catch(function (error) {
        return Promise.reject(error);
      });
    }
    /**
     * Call /supplier-agreement/filter
     * returns list of agreements by windowItemId
     * @param windowId
     * @param windowItemId
     */

  }, {
    key: "getByWindowItemId",
    value: function getByWindowItemId(windowId, windowItemId) {
      var _this3 = this;

      return this.supplierAgreementLayer.getByWindowItemId(windowId, [windowItemId]).then(function (agreements) {
        runInAction(function () {
          _this3.list.clear();

          agreements.forEach(function (agreement) {
            _this3.list.set(agreement.id, agreement);
          });
        });
        return _this3.list;
      }).catch(function (error) {
        return Promise.reject(error);
      });
    }
  }]);

  return SupplierAgreementStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Map)], SupplierAgreementStore.prototype, "list", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], SupplierAgreementStore.prototype, "getAll", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [String, String]), __metadata("design:returntype", Promise)], SupplierAgreementStore.prototype, "getByWindowItemId", null);